import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/remove.svg'


const _withScopeId = n => (_pushScopeId("data-v-08e60e09"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: "baseTavolaItem pointer",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.empty && _ctx.empty(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["baseTavolaColor", { selected: !_ctx.localValue.url }])
    }, [
      _hoisted_1,
      _createVNode(_component_localized_text, {
        class: "text-black fw-bold",
        localizedKey: "Nessuna tovaglietta",
        text: "Nessuna tovaglietta"
      })
    ], 2)
  ]))
}